import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileButtonControlView {
    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setButtonsHeight(element);
    }

}

const mobileButtonControlView = new MobileButtonControlView();
export default mobileButtonControlView;